<template lang="pug">
.main-content-padded
  .vspace.large
  .row
    .col.s12
      .bcrumb
        router-link(:to='{ path: "/inventories" }') Inventories
        router-link(
          v-if='inventoryName',
          :to='{ name: "inventory-details", params: { inventoryName: inventoryName } }'
        )
          | {{ inventoryName }}
        a(v-if='$router.currentRoute.name === "inventory-upload"') Upload
  .row
    .col.s12
      router-view(v-bind='{ inventory: inventory }')
</template>
<script>
export default {
  meta: {
    title: 'Inventory'
  },
  data () {
    return {
      inventory: {
        id: null,
        name: null,
        productVariants: []
      }
    }
  },
  created () {
    this.getInventoryByName()
  },
  computed: {
    inventoryName () {
      return this.$route ? this.$route.params.inventoryName : null
    },
    supplier () {
      return this.$store.state.profile.supplier
    }
  },
  watch: {
    '$route.params.inventoryName' () {
      this.getInventoryByName()
    },
    'supplier.id' () {
      this.getInventoryByName()
    }
  },
  methods: {
    getInventoryByName () {
      if (!this.supplier) {
        return
      }

      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http
          .get(
            `${this.$config.API_URL}/suppliers/${this.supplier.id}/inventories`,
            {
              // params: {
              //   name: this.$route.params.inventoryName,
              // },
              headers: {
                authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then((result) => {
            if (result.data.length > 0) {
              this.inventory = result.data[0]
            }
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-inventory.vue